import { useTranslation } from "react-i18next";
import { FileSearch, AlertCircle } from "lucide-react";
import { PositionCard } from "./PositionCard";
import type { BoqPage, BoqPosition } from "./types";

export const PagePositionsView = ({
  currentPage,
  positions,
}: {
  currentPage: BoqPage | null;
  positions: BoqPosition[];
}) => {
  const { t } = useTranslation();

  if (!currentPage) {
    return (
      <div className="flex flex-col items-center justify-center h-32 text-gray-400 gap-2">
        <FileSearch size={24} className="text-gray-300" />
        <span className="text-sm">
          {t("smartSurveyor.researchReport.selectPage")}
        </span>
      </div>
    );
  }

  if (currentPage.hasError) {
    return (
      <div className="rounded-xl bg-red-50 border border-red-200 px-4 py-4 flex items-start gap-3">
        <AlertCircle size={16} className="text-red-500 mt-0.5 shrink-0" />
        <span className="text-sm text-red-700">
          {t("smartSurveyor.researchReport.extractionError")}
        </span>
      </div>
    );
  }

  if (positions.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-32 text-gray-400 gap-2">
        <span className="text-2xl">—</span>
        <span className="text-sm">
          {t("smartSurveyor.researchReport.noPositionsOnPage")}
        </span>
        {currentPage.sectionContext && (
          <span className="text-xs text-gray-300">
            Section: {currentPage.sectionContext}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {currentPage.sectionContext && (
        <div className="text-xs text-gray-500 font-medium bg-white border border-gray-200 rounded-lg px-3.5 py-2">
          Section: {currentPage.sectionContext}
        </div>
      )}
      {positions.map((pos, i) => (
        <PositionCard key={i} position={pos} />
      ))}
    </div>
  );
};
